<template>
  <v-container class="container">
    <div class="divbody">
      <v-row align="center" justify="center" class="sign-row">
        <v-col align="center" justify="center" cols="12" lg="5">
          <v-card class="login-card" v-if="!haveUser">
            <v-card-title class="con-title text-no-wrap">
              Connexion
            </v-card-title>

            <div class="fields">
              <v-text-field
                v-model="email"
                label="email"
                outlined
                dense
              ></v-text-field>
              <v-text-field
                v-model="password"
                :type="show1 ? 'text' : 'password'"
                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                label="mot de passe"
                @click:append="show1 = !show1"
                outlined
                dense
              ></v-text-field>
              <p class="passwordforgot">Mot de passe oublié ?</p>
            </div>
            <v-btn outlined class="login text-none" @click="signIn">
              Se connecter
            </v-btn>
            <p class="signup pt-4">
              Vous n’avez pas de compte ?
              <span
                class="font-weight-medium sign-up-span"
                @click="goTo('Inscription')"
              >
                Inscrivez-vous !
              </span>
            </p>
          </v-card>
          <v-card v-else>
            <v-card-title>
              Vous êtes déjà connecté
            </v-card-title>
            <p>Prénom: {{ getUser.firstname }}</p>
            <p>Nom: {{ getUser.name }}</p>
            <p>Email: {{ getUser.email }}</p>
            <p>Structure: {{ getUser.structure }}</p>
            <p>Fonction: {{ getUser.fonction }}</p>
            <p>Phone: {{ getUser.phone }}</p>
            <p>Civilité: {{ getUser.civility }}</p>

            <v-btn text @click="logout">
              Logout
            </v-btn>
          </v-card>
        </v-col>
        <v-col align="center" justify="center" cols="12" lg="7">
          <CImage
            :url="'small_house.svg'"
            :square="false"
            :alt="'image not found'"
          />
        </v-col>
      </v-row>
    </div>
    <v-bottom-sheet v-model="sheet.display">
      <v-sheet class="text-center" height="200px">
        <v-btn
          class="mt-6"
          text
          color="red"
          @click="sheet.display = !sheet.display"
          >Continuer</v-btn
        >
        <div class="py-3">{{ sheet.text }}</div>
      </v-sheet>
    </v-bottom-sheet>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import CImage from "../components/HomeSections/SubComponents/Image";
import { logIn, logOut } from "@/services/user";

export default {
  data() {
    return {
      show1: false,
      email: "",
      password: "",
      sheet: {
        display: false,
        text: ""
      }
    };
  },
  components: { CImage },
  computed: {
    ...mapGetters({
      haveUser: "userModule/haveUser",
      getUser: "userModule/getUser"
    })
  },
  methods: {
    goTo(name) {
      console.log("Name", name);
      this.redirect(name);
    },
    signIn() {
      logIn(this.email, this.password).catch(error => {
        var errorCode = error.code;
        var errorMessage = error.message;

        this.sheet.display = true;
        this.sheet.text = errorCode + ": " + errorMessage;
        this.email = "";
        this.password = "";
      });
    },
    logout() {
      let that = this;
      logOut()
        .then(() => {
          that.sheet.display = true;
          that.sheet.text = "Déconnecté";
        })
        .catch(error => {
          that.sheet.display = true;
          that.sheet.text = error;
        });
    }
  }
};
</script>

<style scoped>
.divbody {
  padding: 5%;
}
.container {
  height: 100%;
  max-width: 8000px !important;
  padding: 0;
  margin: 0;
  background-color: #fafefe;
}

.sign-row {
  padding: 20px;
}

.fields * {
  padding: 0px 15px;
}

.sign-up-span:hover {
  color: "secondary";
  cursor: pointer;
}

.login-card {
  background-color: white !important;
  padding: 30px;
  border-radius: 50px;
}

.signup {
  font-family: Poppins;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
}

.login-card {
  padding: 15px;
}

.passwordforgot {
  font-family: Poppins;
  font-style: normal;
  font-weight: 300;
  font-size: 14px;
  line-height: 22px;
  padding-bottom: 0 !important;
  cursor: pointer;
}

.login {
  font-family: Poppins;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  background-color: #e0e8f9;
  border-color: #98aeeb;
  color: #19216c;
  text-decoration: none;
}

.con-title {
  display: block;
  text-align: center;
  font-family: Poppins;
  font-style: normal;
  font-weight: 600;
  font-size: 45px;
  line-height: 64px;
  padding-bottom: 50px;
  color: #262626;
}
</style>
